/* eslint-disable react/no-unescaped-entities */
import HeroPlain from 'components/landing/HeroPlain';
import nonAuth from 'utils/nonAuth';
import { useTranslation } from 'next-i18next';

const TermsConditions = () => {
  const { t } = useTranslation();

  const termsAndConditionsContent = [
    {
      title: 'Information We Collect',
      description: '',
      listItems: [
        'Personal Information: When you sign up for an account on OnBoard, we may collect personal information such as your name, email address, contact number, and other relevant details needed for creating your profile and facilitating communication with potential employers.',
        'Profile Information: To enhance your experience and improve job matching, you have the option to provide additional profile information such as your work experience, qualifications, certifications, and preferences.',
        'Job Post Information: Companies posting job vacancies on OnBoard will provide information about the job positions, requirements, and company details.',
        'Usage Information: We may collect information on how you interact with the app, including your search queries, job applications, app preferences, and other usage data.',
        'Device and Log Information: We may automatically collect technical information about your device, such as your IP address, device type, operating system, app version, and app usage logs.',
      ],
    },
    {
      title: 'How We Use Your Information',
      description: '',
      listItems: [
        'Job Matching: We use the information you provide to match you with relevant job opportunities based on your qualifications, preferences, and experience.',
        'Communication: We use your contact information to facilitate communication between seafarers and companies during the job application process.',
        'App Improvement: Your usage information helps us analyze app performance and identify areas for improvement.',
        'Compliance: We may use your data to comply with legal obligations, enforce our terms of service, and protect our rights and the rights of other users.',
      ],
    },
    {
      title: 'Data Sharing and Disclosure',
      description: '',
      listItems: [
        'Job Applications: When you apply for a job through OnBoard, the relevant information you provide will be shared with the company posting the job vacancy.',
        'Third-Party Services: We may share your information with third-party service providers who assist us in app development, analytics, customer support, and other essential functions.',
        'Aggregated Data: We may share non-identifiable, aggregated data for statistical analysis and marketing purposes.',
        'Legal Requirements: We may disclose your information when required by law, in response to legal process, or to protect our rights, privacy, safety, or property.',
      ],
    },
    {
      title: 'Data Security',
      description:
        'We take data security seriously and implement reasonable measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is entirely secure. While we strive to use commercially acceptable means to protect your data, we cannot guarantee its absolute security.',
      listItems: [],
    },
    {
      title: 'Your Choices and Rights',
      description: '',
      listItems: [
        "Access and Correction: You can access and edit your profile information through the app's settings.",
        'Account Deletion: If you wish to delete your account, please contact our support team, and we will assist you in the process.',
        'Marketing Communications: You have the right to opt-out of receiving promotional emails or messages from us. However, you may still receive essential service-related communications.',
      ],
    },
    {
      title: "Children's Privacy",
      description:
        'OnBoard is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children. If we discover that we have inadvertently collected data from a child, we will promptly delete it.',
      listItems: [],
    },
    {
      title: 'Changes to the Privacy Policy',
      description: '',
      listItems: [
        'We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. When we make changes, we will revise the "Effective Date" at the top of the policy. Please review this page regularly for any updates.',
      ],
    },
    {
      title: 'Contact Us',
      description:
        'If you have any questions or concerns about this Privacy Policy or your data, please contact us at hello@onboardcrewapp.com.',
      listItems: [],
    },
  ];

  return (
    <div className='relative bg-white -mb-200'>
      <HeroPlain title={t('TermsConditions')}>
        <p className="text-regular2 font-medium text-grey-dark">
          Effective date: 31 July 2023
        </p>
      </HeroPlain>
      <section className="relative max-w-screen-md w-full mx-auto mt-20 px-20 desktopSmall:px-40 pt-72 pb-100">
        <div>
          <p className="text-lg3">
            Welcome to OnBoard, the app that connects seafarers with their dream
            jobs and allows companies to post job vacancies in the maritime
            industry. At OnBoard, we are committed to protecting your privacy
            and ensuring the security of your personal information. This Privacy
            Policy outlines how we collect, use, disclose, and safeguard your
            data when you use our app.
          </p>

          <p className="text-lg3 mb-24 mt-20">
            By accessing or using the OnBoard app, you consent to the practices
            described in this Privacy Policy. If you do not agree with the terms
            of this policy, please do not use the app.
          </p>
        </div>
        <div>
          {termsAndConditionsContent.map((item, index) => (
            <div key={item.title} className='mb-24'>
              <p className="text-xl3 font-semibold my-12">
                {index + 1}. {item.title}
              </p>
              {item.description && <p>{item.description}</p>}
              <ul className="list-disc list-outside flex flex-col gap-8 pl-16">
                {item.listItems.map((listItem) => (
                  <li key={listItem}>{listItem}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default nonAuth(TermsConditions);
